import { useQuery } from '@tanstack/react-query';

import { shippingOptionsQuery } from './shippingOptionsQuery';

export function useShippingOptions() {
  return useQuery(shippingOptionsQuery());
}
